// priceRules.js

const priceRules = [
    {
      id: "hell",
      formula: "1",
      porice1: ["ref_sideLiteGlass", "doorData.sideLite.sideLiteOptionsS_label"],
      porice2: ["Gentek", "doorData.frameData.frameColor"],
      unitPrice: 7,
      multiplicator: {
        condition: "true",
        value: 2
      }
    }
  ];
  
  export default priceRules;
  